import React from 'react';
// Components
import Banner from '../../../components/Banner/Banner';
import './MiknatisSactirmaKaynaklari.css';

const MiknatisSactirmaKaynaklari = () => {
  return (
    <div className="miknatis-sactirma-kaynaklari-page">
      {/* Main Content */}
      
      {/* Banner */}
      <Banner
        title="Mıknatıssal Saçtırma Kaynakları"
        backgroundImage={require('../../../assets/images/inner-banner.jpg')}
      />
      
      {/* Page Content */}
      <section className="miknatis-sactirma-content">
        <div className="container content-container">
          
          {/* Section 1: 2 inç Mıknatıssal Saçtırma Kaynağı */}
          <div className="section section-2inch">
            <h2 className="section-heading">2 inç Mıknatıssal Saçtırma Kaynağı</h2>
            <div className="row">
              <div className="column">
                <img 
                  src={require('../../../assets/images/pasted-image.jpg')}
                  alt="2 inç Kaynak - Görsel 1" 
                  className="img-fluid"
                />
              </div>
              <div className="column">
                <img 
                  src={require('../../../assets/images/pasted-image-1.jpg')}
                  alt="2 inç Kaynak - Görsel 2" 
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="list-section">
              <ul>
                <li>Özellik 1: XXX</li>
                <li>Özellik 2: YYY</li>
              </ul>
            </div>
          </div>
          
          {/* Section 2: Tersinmiş (Inverted) Mıknatıssal Saçtırma Kaynağı */}
          <div className="section section-inverted">
            <h2 className="section-heading">Tersinmiş (Inverted) Mıknatıssal Saçtırma Kaynağı</h2>
            <div className="list-section">
              <ul>
                <li>Özellik A: XXX</li>
                <li>Özellik B: YYY</li>
              </ul>
            </div>
          </div>
          
          {/* Section 3: TANK Camı */}
          <div className="section section-tank-cam">
            <div className="row">
              <div className="column">
                <img 
                  src={require('../../../assets/images/AF3280DF-1A22-4A61-AD88-D75F363FA720.jpeg')} 
                  alt="TANK Camı Örneği" 
                  className="img-fluid"
                />
              </div>
              <div className="column">
                <h5>Indium tin oxide, indiyum kalay oksit kaplı TANK camı</h5>
                <p>
                  ITO (Indium tin oxide, indiyum kalay oksit) elektriksel iletken ve optik geçirgen bir ince film kaplama çeşididir.
                  Bu kaplamalar güneş pillerinde, elektrokromik camlarda, LCD ekranlarda, OLED displaylerde ve ısı bariyerleri olarak kullanılmaktadır.
                </p>
                <ul>
                  <li>ITO kaplamalar 1.3×10<sup>-4</sup> ohm.cm’den düşük özdirence sahiptir.</li>
                  <li>Görünür bölgede ışık geçirgenliği %85’in üzerindedir.</li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Section 4: Mıknatıssal Saçtırma Güç Kaynağı */}
          <div className="section section-power-supply">
            <div className="row">
              <div className="column">
                <h5 className="section-heading">Mıknatıssal Saçtırma Güç Kaynağı (1 kW)</h5>
                <p>
                  TEKNOMA VN-1001P, 2 inçten 4 inçe kadar olan kaynaklar için tasarlanmış, dijital ekranlı ve ayarlı bir güç kaynağıdır.
                  Ark önleme, sabit çalışma ve plazma kayıp uyarısı özellikleri ile donatılmıştır.
                </p>
                <ul>
                  <li>1 kW DC güç</li>
                  <li>220V, 1 faz</li>
                </ul>
                <p>Fiyat: 2500 USD + KDV</p>
              </div>
              <div className="column">
                <img 
                  src={require('../../../assets/images/021EAB6C-1B64-47E9-91A0-CE6E26A98F93.jpeg')} 
                  alt="Mıknatıssal Saçtırma Güç Kaynağı" 
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          
          {/* Section 5: Magnetron Sputtering System */}
          <div className="section section-sputtering">
            <div className="row">
              <div className="column">
                <img 
                  src={require('../../../assets/images/pasted-image-1.jpg')} 
                  alt="Magnetron Sputtering System" 
                  className="img-fluid"
                />
              </div>
              <div className="column">
                <h5>Magnetron Sputtering System</h5>
                <p>
                  Bu sistem, ince film üretimi için DC veya RF ile çalışabilen, 2 inç hedefler için özel olarak tasarlanmış bir saçtırma kaynağıdır.
                </p>
                <ul>
                  <li>İntensif film kaplama</li>
                  <li>Yüksek vakumda çalışma</li>
                </ul>
                <p>Fiyat: 2500 USD + KDV</p>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      
    </div>
  );
};

export default MiknatisSactirmaKaynaklari;
